import { render, staticRenderFns } from "./DdmOrgExport.vue?vue&type=template&id=a3facab4&scoped=true&"
import script from "./DdmOrgExport.vue?vue&type=script&lang=js&"
export * from "./DdmOrgExport.vue?vue&type=script&lang=js&"
import style0 from "./DdmOrgExport.vue?vue&type=style&index=0&id=a3facab4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3facab4",
  null
  
)

export default component.exports